import React from 'react';
import styled from 'styled-components';
import SharedPageLayout from './SharedPageLayout';
import NewsSection from './NewsSection';
import { theme } from '../theme';

const NewsPageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background: ${theme.colors.white};
`;

const NewsPage: React.FC = () => {
  return (
    <SharedPageLayout
              backgroundImage="/shared_assets/images/news-hero.jpg"
      heroType="search"
      pageTitle="Actualités d'Algérie"
      pageDescription="Restez informé des dernières nouvelles et événements importants en Algérie"
    >
      <NewsPageContainer>
        <NewsSection maxArticles={12} showLoadMore={true} />
      </NewsPageContainer>
    </SharedPageLayout>
  );
};

export default NewsPage; 